import * as React from "react";
import { Button, ModalFooter, cn } from "@racoon/ui";

/** A step's scrolling body plus a pinned footer. List steps pass no actions. */
export const StepShell: React.FC<{
  children: React.ReactNode;
  /** The create/primary action. Omitted on the list-only steps. */
  primary?: { label: string; onClick: () => void; disabled?: boolean };
  /** Only rendered once the step's entity exists — there is nothing to update before that. */
  secondary?: { label: string; onClick: () => void; disabled?: boolean };
  bodyClassName?: string;
}> = ({ children, primary, secondary, bodyClassName }) => (
  <div className="flex min-h-0 flex-1 flex-col">
    <div className={cn("min-h-0 flex-1 overflow-y-auto p-4", bodyClassName)}>{children}</div>
    <ModalFooter className="shrink-0">
      {primary && (
        <Button
          type="button"
          size="sm"
          variant="solidBlue"
          onClick={primary.onClick}
          disabled={primary.disabled}
        >
          {primary.label}
        </Button>
      )}
      {secondary && (
        <Button
          type="button"
          size="sm"
          variant="opacityBlueWithoutOutline"
          onClick={secondary.onClick}
          disabled={secondary.disabled}
        >
          {secondary.label}
        </Button>
      )}
    </ModalFooter>
  </div>
);
